import { gql } from 'graphql-request'

export const CHECK_COUPON_CODE = gql`
  query CheckCouponCode($couponCode: String!) {
    checkCouponCodeAlreadyExist(couponCode: $couponCode)
  }
`
